type CheckCircleIconProps = {
  color: 'darkpurple' | 'lightpurple' | 'green' | 'blue' | 'peach' | 'white';
  // Optional accessible label (e.g. "Covered", "In-network").
  // Omit to keep the icon purely decorative (the default).
  label?: string;
};

function CheckCircleIcon({ color, label }: CheckCircleIconProps) {
  const COLORS = {
    green: 'var(--success-600)',
    lightpurple: 'var(--purple-500)',
    darkpurple: 'var(--purple-700)',
    blue: 'var(--blue-600)',
    peach: 'var(--peach-dark)',
    white: 'white',
  };
  const a11yProps = label
    ? { role: 'img' as const, 'aria-label': label }
    : { 'aria-hidden': true as const, focusable: 'false' as const };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...a11yProps}
    >
      <path
        d="M12.125 2.04688C14.797 2.04985 17.3587 3.11258 19.248 5.00195C21.1374 6.89132 22.2001 9.45303 22.2031 12.125C22.2031 14.1181 21.6121 16.0664 20.5049 17.7236C19.3975 19.381 17.823 20.6728 15.9814 21.4355C14.14 22.1983 12.114 22.3985 10.1592 22.0098C8.20422 21.6209 6.40847 20.6604 4.99902 19.251C3.58957 17.8415 2.6291 16.0458 2.24023 14.0908C1.85147 12.136 2.05174 10.11 2.81445 8.26855C3.57724 6.42702 4.86903 4.85252 6.52637 3.74512C8.08006 2.70709 9.88955 2.12268 11.752 2.05371L12.125 2.04688ZM15.1562 4.80566C13.7088 4.20623 12.1156 4.04983 10.5791 4.35547C9.04257 4.66119 7.63123 5.41565 6.52344 6.52344C5.41565 7.63123 4.66119 9.04257 4.35547 10.5791C4.04983 12.1156 4.20623 13.7088 4.80566 15.1562C5.40524 16.6037 6.42093 17.8415 7.72363 18.7119C8.94505 19.528 10.3679 19.9868 11.832 20.041L12.125 20.0469C14.2253 20.0446 16.2395 19.2098 17.7246 17.7246C19.2098 16.2395 20.0446 14.2253 20.0469 12.125C20.0469 10.5582 19.5824 9.02638 18.7119 7.72363C17.8415 6.42093 16.6037 5.40524 15.1562 4.80566ZM15.876 8.79492C16.0175 8.79523 16.1574 8.8235 16.2881 8.87793C16.4189 8.93242 16.5378 9.0119 16.6377 9.1123C16.7382 9.21247 16.8177 9.33184 16.8721 9.46289C16.9264 9.59389 16.9551 9.73414 16.9551 9.87598C16.9551 10.0178 16.9264 10.1581 16.8721 10.2891C16.8312 10.3875 16.7765 10.4795 16.709 10.5615L16.6377 10.6396L11.3877 15.8896C11.2875 15.9902 11.1682 16.0696 11.0371 16.124C10.9061 16.1784 10.7658 16.207 10.624 16.207C10.4822 16.207 10.3419 16.1784 10.2109 16.124C10.1125 16.0831 10.0204 16.0285 9.93848 15.9609L9.86035 15.8896L7.61035 13.6396C7.51006 13.5394 7.43025 13.4201 7.37598 13.2891C7.32177 13.1581 7.29395 13.0177 7.29395 12.876C7.29395 12.7343 7.32178 12.5938 7.37598 12.4629C7.43025 12.3319 7.51008 12.2126 7.61035 12.1123C7.71065 12.012 7.8299 11.9322 7.96094 11.8779C8.0919 11.8237 8.23228 11.7959 8.37402 11.7959C8.51576 11.7959 8.65615 11.8237 8.78711 11.8779C8.91815 11.9322 9.0374 12.012 9.1377 12.1123L10.5918 13.5645L10.625 13.5977L10.6582 13.5645L15.1123 9.10938C15.2126 9.00936 15.332 8.92998 15.4629 8.87598C15.5938 8.82205 15.7344 8.79467 15.876 8.79492Z"
        fill={COLORS[color]}
        stroke={COLORS[color]}
        strokeWidth="0.09375"
      />
    </svg>
  );
}

export default CheckCircleIcon;
